import { useMutation, useQueryClient } from "@tanstack/vue-query";
import { ApiResponse } from "@/utils/ApiResponse";
import { CategoriasProductoInterface } from "../../interfaces/categoriaInterfaces/CategoriasProducto.interface";
import { useToast } from "vue-toastification";
import { DeleteCategoriaProductoAction } from "../../actions/categoriaActions";

const toast = useToast();

export function useCategoriaProductoDelete(onClose?: () => void) {
  const queryClient = useQueryClient();
  // Mutation para eliminar la categorÃ­a
  const mutation = useMutation({
    mutationFn: (categoriaId: string) =>
      DeleteCategoriaProductoAction(categoriaId),
    onSuccess: async (response: ApiResponse<CategoriasProductoInterface>) => {
      await queryClient.invalidateQueries({
        queryKey: ["CategoriaProductosList"],
      });

      toast.success("La categoría fue eliminada correctamente");
      if (onClose) onClose();
    },
    onError: () => {
      toast.error("No se pudo eliminar la categoría.");
      if (onClose) onClose();
    },
  });
  return {
    ...mutation, // => { mutate, mutateAsync, isPending, isError, error, isSuccess, data }
  };
}
